import React, { useMemo } from 'react';
import { Nullable } from 'global';
import { Stack, Typography } from '@mui/material';
import { Listing } from 'components/shared/TableListing';

import { QuoteCalcProfitability } from '../../../api/types';
import { DealerProfitabilityListingEntity } from '../../../types';
import { DealerProfitabilityListingColumns } from './dealerProfitabilityListingConfig';

interface Props {
  profitability: Nullable<QuoteCalcProfitability>;
}

export const DealerProfitability = ({ profitability }: Props) => {
  const { netSellingPrice = 0, totalDealerCost = 0, grossProfit = 0, marginRate = 0 } = profitability ?? {};

  const tableData = useMemo<DealerProfitabilityListingEntity>(
    () => ({ netSellingPrice, totalDealerCost, grossProfit, marginRate }),
    [netSellingPrice, totalDealerCost, grossProfit, marginRate]
  );

  return (
    <Listing<DealerProfitabilityListingEntity>
      tableData={[tableData]}
      columns={DealerProfitabilityListingColumns}
      actionPanelTop={() => (
        <Stack>
          <Typography variant="h6" component="span">
            Dealer Profitability
          </Typography>
        </Stack>
      )}
    />
  );
};
